// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.accordion_wrapper {
  padding: 5px;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;
  margin-left: 25px;
  color: rgba(0, 0, 0, 0.6);
  transition: all 200ms;
  cursor: default;
}
.accordion_wrapper:hover {
  box-shadow: rgba(50, 50, 50, 0.15) 4px 5px 10px;
}
.accordion_wrapper .accordion_tab {
  transition: all 200ms;
  max-height: 0px;
  overflow: hidden;
}
.accordion_wrapper .tab_title:hover {
  color: rgb(0, 0, 0);
}
.accordion_wrapper .tab_title.level_1 {
  cursor: pointer;
  padding: 10px 0;
}
.accordion_wrapper .tab_title.level_2 {
  cursor: pointer;
  font-size: 12px;
  padding: 5px 0;
}
.accordion_wrapper .tab_title.level_3 {
  font-size: 12px;
  padding: 5px 0;
}
.accordion_wrapper .tab_title.open + .accordion_tab {
  max-height: 200px;
  overflow-y: auto;
}
.accordion_wrapper .tab_content {
  cursor: pointer;
  display: flex;
  padding: 5px;
  align-items: center;
  justify-content: space-between;
}
.accordion_wrapper .tab_content span {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/leaflet/dealer-tab/_dealerTab.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC9HA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8CDwGS;ECvGT,iBAAA;EACA,yBDYmB;ECXnB,qBAAA;EACA,eAAA;AAkEJ;AAhEI;EACI,+CDkGW;AChCnB;AA9DI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;AAgER;AA5DQ;EACI,mBDNM;ACoElB;AA5DQ;EACI,eAAA;EACA,eAAA;AA8DZ;AA5DQ;EACI,eAAA;EACA,eAAA;EACA,cAAA;AA8DZ;AA5DQ;EACI,eAAA;EACA,cAAA;AA8DZ;AA3DQ;EACI,iBAAA;EACA,gBAAA;AA6DZ;AA1DI;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AA4DR;AA3DQ;EACI,eAAA;AA6DZ","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../../styles/variables\";\r\n\r\n.accordion_wrapper {\r\n    padding: 5px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: $row_shadow;\r\n    margin-left: 25px;\r\n    color: $text_color_dark_soft;\r\n    transition: all $transition_speed;\r\n    cursor: default;\r\n\r\n    &:hover {\r\n        box-shadow: $row_shadow_hover;\r\n    }\r\n\r\n\r\n    .accordion_tab {\r\n        transition: all $transition_speed;\r\n        max-height: 0px;\r\n        overflow: hidden;\r\n    }\r\n    .tab_title {\r\n\r\n        &:hover {\r\n            color: $text_color_dark;\r\n        }\r\n        &.level_1 {\r\n            cursor: pointer;\r\n            padding: 10px 0;\r\n        }\r\n        &.level_2 {\r\n            cursor: pointer;\r\n            font-size: 12px;\r\n            padding: 5px 0;\r\n        }\r\n        &.level_3 {\r\n            font-size: 12px;\r\n            padding: 5px 0;\r\n        }\r\n\r\n        &.open + .accordion_tab {\r\n            max-height: 200px;\r\n            overflow-y: auto;\r\n        }\r\n    }\r\n    .tab_content {\r\n        cursor: pointer;\r\n        display: flex;\r\n        padding: 5px;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        span {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    .tab_icon {\r\n        // svg {\r\n        //     color: $text_color_dark_soft;\r\n        //     cursor: pointer;\r\n        //     margin: 2px 6px;\r\n        //     font-size: 12px;\r\n        //     &:hover {\r\n        //         color: $color_primary;\r\n        //         transform: scale(1.1);\r\n        //     }\r\n        // }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
